export default __webpack_public_path__ + "static/constImg_LanArea-1895ee9485314c34015880f14798d069.png";